import axios, {AxiosRequestConfig} from 'axios';
import {AxiosRequestConfigExt} from '../service';

export function getRequestPromise(url: string, config: AxiosRequestConfigExt): Promise<any> {
  return axios(url, config as AxiosRequestConfig);
}
